// extracted by mini-css-extract-plugin
module.exports = {"proposal":"styles_proposal__XP64O"};